import Joi from 'joi';
import { passwordRegex } from '../constant/constant';

export const patientRegisterValidator = (payload: unknown) => {
  const obj = Joi.object().keys({
    userData: Joi.object().keys({
      title: Joi.string().optional().allow(null).allow(''),
      firstName: Joi.string().required(),
      lastName: Joi.string().required(),
      password: Joi.string().pattern(new RegExp(passwordRegex)),
      email: Joi.string()
        .email({ maxDomainSegments: 2, tlds: { allow: false } })
        .required()
        .pattern(
          new RegExp('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$'),
        ),
      gender: Joi.allow(
        'Male',
        'Female',
        'Non-binary',
        'Gender-diverse',
        'Transgender',
        'Different-identity',
      ).required(),
      mobile: Joi.string().length(9).required(),
      dob: Joi.string().required(),
    }),
    address: Joi.object()
      .keys({
        address_line_one: Joi.string().optional().allow(null).allow(''),
        address_line_two: Joi.string().optional().allow(null).allow(''),
        city: Joi.string().optional().allow(null).allow(''),
        state: Joi.string().optional().allow(null).allow(''),
        post_code: Joi.number().optional().allow(null).allow(''),
        street_number: Joi.string()
          .optional()
          .allow(null)
          .allow('')
          .allow('undefined'),
        street_name: Joi.string()
          .optional()
          .allow(null)
          .allow('')
          .allow('undefined'),
      })
      .optional(),

    emergency_contact_information: Joi.object()
      .keys({
        contact_name: Joi.string().optional().allow(null).allow(''),
        contact_number: Joi.string().optional().allow(null).allow(''),
        contact_relationship: Joi.string().optional().allow(null).allow(''),
        consent: Joi.boolean().optional(),
      })
      .optional(),
  });

  const { error } = obj.validate(payload);

  return error ? error.details : false;
};
